<template>
  <div id="app">
    <div class="asset-loading-container bg" v-if="isAssetLoading">
      <div class="loading-container">
        <div class="icon"></div>
        <div class="text">{{$t('系统加载中')}}...</div>
      </div>
    </div>
    <router-view></router-view>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters({
      isAssetLoading: 'isAssetLoading',
    }),
  },
  mounted() {
    const language = localStorage.getItem('Language') || 'en'
    this.$i18n.locale = language
  },
}
</script>

<style lang="scss">
@import '@/assets/scss/common.scss';
.asset-loading-container {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background-color: white;
  .loading-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    .icon {
      width: 100px;
      height: 100px;
      background-color: #DDDDDD;
      margin-bottom: 40px;
    }
    .text {
      font-size: 28px;
      font-weight: 700;
      word-spacing: 10px;
    }
  }
}
</style>
